// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".pdp." + "4c15adb526598ff23fbbe9a8c943b898a0cfe451" + ".css";
};